import React from "react";
import "../css/filters.css";

import { useStore } from "../store/Store";
import {
  Button,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField,
  Select,
  MenuItem,
  InputLabel,
} from "@material-ui/core";
import { Multiselect } from "./MultiSelectDropdown";

export const LIMIT = 1000;

const multiselectDesign = {
  searchBox: {
    padding: "1em",
  },
  chips: {
    background: "#28a745",
    fontSize: "12px",
  },
  option: {
    color: "black",
  },
};

const Filters = (props: any) => {
  const { dispatch, state } = useStore();
  const [sortByOption, setSortByOption] = React.useState("name");

  // For multiselect dropdown
  const onSelectDropdown = (selectedList: any, selectedItem: any) => {
    dispatch({
      type: "SET_FILTER_QUERY",
      filterQuery: { ...state.filterQuery, tags: selectedList },
    });
  };

  const updateSearchQueryText = (value: any): void => {
    dispatch({
      type: "SET_FILTER_QUERY",
      filterQuery: { ...state.filterQuery, textSearch: value },
    });
  };

  const updateSearchQueryKeywordSelector = (event: {
    target: { value: any };
  }) => {
    dispatch({
      type: "SET_FILTER_QUERY",
      filterQuery: {
        ...state.filterQuery,
        keywordsSelectorOperation: event.target.value,
      },
    });
  };

  const keyPressed = (event: any) => {
    if (event.key === "Enter") {
      props.search(false);
    }
  };

  const handleChangeSortDropdown = (event: any) => {
    setSortByOption(event.target.value);
    dispatch({
      type: "SET_FILTER_QUERY",
      filterQuery: { ...state.filterQuery, sortBy: event.target.value },
    });
  };

  return (
    <form onSubmit={(e: { preventDefault: () => void }) => e.preventDefault()}>
      <Grid
        container
        spacing={1}
        style={{ marginBottom: "20px" }}
        justify="center"
      >
        <Grid item xs={12} className={"filter-search"}>
          <TextField
            placeholder="Find by author, journal or title"
            className="search-text-field"
            variant="outlined"
            name="search"
            onKeyPress={keyPressed}
            onChange={(e) => updateSearchQueryText(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} className={"more-filters"}>
          <Multiselect
            options={state.filters}
            groupBy="tag_type_name"
            displayValue="tag_name"
            showCheckbox={true}
            onSelect={onSelectDropdown}
            closeOnSelect={false}
            placeholder="Keywords"
            style={multiselectDesign}
          />
        </Grid>
        <Grid item sm={9}>
          <RadioGroup
            row
            name="keywordsSelectorOperation"
            value={state.filterQuery.keywordsSelectorOperation}
            onChange={updateSearchQueryKeywordSelector}
            style={{ justifyContent: "center" }}
          >
            <FormControlLabel
              value="and"
              control={<Radio />}
              label="Search publications that include all of the selected keywords."
            />
            <FormControlLabel
              value="or"
              control={<Radio />}
              label="Search publications that include any of the selected keywords."
            />
          </RadioGroup>
        </Grid>
        <Grid item xs={8} sm={3}>
          <Grid container>
            <Grid item xs={3} sm={4}>
              <InputLabel style={{ padding: "0.5rem" }}>Sort by</InputLabel>
            </Grid>
            <Grid item xs={9} sm={8}>
              <Select
                value={sortByOption}
                onChange={handleChangeSortDropdown}
                label="Sort"
                style={{ width: "100%" }}
              >
                <MenuItem value={"name"}>Name</MenuItem>
                <MenuItem value={"latest"}>Latest</MenuItem>
                <MenuItem value={"oldest"}>Oldest</MenuItem>
              </Select>
            </Grid>
          </Grid>
        </Grid>
        <Grid item sm={4} xs={12}>
          <Button
            style={{
              width: "100%",
              height: "45px",
              fontSize: "18px",
            }}
            className="btn btn-success"
            onClick={() => props.search(false)}
          >
            Search
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};
export default Filters;
